import React from "react";
import AddUpdateUI from "./AddUpdateUI";

const AddUpdateCountry = ({ formik }) => {
  return <AddUpdateUI formik={formik} />;
};

export default AddUpdateCountry;
